import { render, staticRenderFns } from "./GoogleWallet.vue?vue&type=template&id=836dc45e&"
import script from "./GoogleWallet.vue?vue&type=script&lang=js&"
export * from "./GoogleWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports